// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction3_wrapper__JsPtn","button":"introduction3_button__-7ROZ"};